import { get } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../../../context/AuthProvider';
import CartContext from '../../../context/CartProvider';

import { useToast } from '@chakra-ui/react';
import Icon from 'components/atoms/Icon/Icon';
import { useCartStore } from 'stores/cart';
import Button from '../../atoms/Button/Button';
import * as styles from './AddToCartButton.module.css';

const AddToCartButton = ({
  children,
  productId,
  variantId,
  additionalAction,
  extraItems = [],
  className,
  options = [],
  selectedVariant,
  track,
  tracker,
  size,
  product,
  skipCartModal = false,
  quantity,
  fullWidth,
  quickCheckout = false,
  disabled = false,
  intercept = false,
  showIcon = false,
  needModifiers = undefined,
  workingMessage = 'Adding to cart',
  buttonStyle = 'primary'
}) => {
  const auth = useContext(AuthContext);
  const { prescription, setPrescription } = useCartStore();
  const isLoggedIn = get(auth, 'state.isLoggedIn', false);
  const userChecked = get(auth, 'state.userChecked', false);
  const [displayQuickCheckout, setDisplayQuick] = useState(false);

  const toast = useToast();

  const value = useContext(CartContext);

  const addToCart = value && value.addToCart;
  const addAllToCart = value && value.addAllToCart;
  const addingToCart = value && value.state.addingToCart;

  useEffect(() => {
    if (userChecked && quickCheckout && isLoggedIn) {
      setDisplayQuick(true);
    }
  }, [quickCheckout, userChecked, isLoggedIn]);

  const submitHandler = e => {
    e.preventDefault();
    e.stopPropagation();
    //check if product need modifier
    if (needModifiers !== undefined && needModifiers().length > 0) {
      return;
    }
    //check variant stock
    if (track && selectedVariant && selectedVariant.inventory_level === 0) {
      toast({
        title: 'Error',
        description: 'The selected variant is out of stock. Please select another variant.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right'
      });
      return;
    }
    //  if have warning show warning popup to confirm add to cart
    if (intercept) {
      if (!prescription) {
        setPrescription(true);
        return;
      }
    }

    if (!variantId) {
      toast({
        title: 'Error',
        description: 'Additional options are required. Please visit the product page.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right'
      });
      return;
    }
    //extraItems auto empty because warranty = false with no condition
    if (extraItems.length > 0) {
      const items = extraItems.map(extraItem => ({
        product_id: extraItem.productId,
        variant_id: extraItem.variantId,
        quantity: extraItem.matchQty && parseInt(quantity, 10) > 0 ? quantity : 1
      }));
      items.push({
        product_id: productId,
        variant_id: variantId,
        quantity: quantity && parseInt(quantity, 10) > 0 ? quantity : 1
      });
      addAllToCart(items);
    } else {
      // if quantity is number then add card
      // with autoship cart add with options, other add with vairiantId
      if (quantity && parseInt(quantity, 10) > 0) {
        // default add to cart
        addToCart({
          productId: productId,
          variantId: variantId,
          quantity,
          options,
          skipCartModal
        });
      } else {
        //  add to cart ?
        addToCart({
          productId: productId,
          variantId: variantId,
          options,
          skipCartModal
        });
      }

      if (tracker) tracker();
    }

    additionalAction && additionalAction(product.url);
  };

  if (!productId) return null;
  if (!quickCheckout || (quickCheckout && displayQuickCheckout)) {
    return (
      <div className={`${styles.root} bc-form bc-addtocart-form`}>
        <div className="bc-product-form__product-message"></div>
        <Button
          level={buttonStyle}
          type="buttonSubmit"
          disabled={disabled || addingToCart === productId}
          size={size}
          onClick={submitHandler}
          className={`${className} ${addingToCart === productId ? styles.addingActive : ''}`}
        >
          {showIcon && <Icon symbol={'cart-plus'} />}
          <span>{addingToCart === productId ? workingMessage : <>{children}</>}</span>
        </Button>
      </div>
    );
  }

  return null;
};

export default AddToCartButton;
